export const getFirstName = (userName) => {
  return userName?.split(' ')?.[0];
};
